import { T } from "../../styles/GlobalStyles";

const SessionTopBar = ({ activeSession, formatDuration, onGoToSession }) => (
  <div style={{ position: "relative", background: T.surface2, padding: "10px 16px", display: "flex", alignItems: "center", gap: 12, overflow: "hidden" }}>
    <span style={{ fontSize: 12, color: T.muted, textTransform: "uppercase", letterSpacing: 1 }}>Séance en cours</span>
    <span style={{ fontSize: 13, fontWeight: 600 }}>{activeSession.client?.emoji} {activeSession.client?.name}</span>
    <span style={{ marginLeft: "auto", fontSize: 13, fontFamily: "Barlow Condensed,sans-serif", fontWeight: 700, color: T.accent }}>
      ⏱ {formatDuration}
    </span>
    <button onClick={onGoToSession} style={{
      marginLeft: 12, padding: "7px 14px", borderRadius: 999,
      border: `1px solid ${T.accent}`, background: T.accentBg,
      color: T.accent, fontSize: 12, fontWeight: 600,
      animation: "nudgePulse 2s ease-in-out infinite",
      "--accent-glow": `${T.accent}50`,
    }}>
      Revenir à la séance →
    </button>
    {/* Static base border */}
    <div style={{
      position: "absolute", bottom: 0, left: 0, right: 0, height: 2,
      background: `${T.accent}20`,
    }} />
    {/* Animated sweep — tapered: thicker center, thinner edges */}
    <div style={{
      position: "absolute", bottom: -1, width: "30%", height: 4,
      background: `radial-gradient(ellipse 50% 100% at center, ${T.accent} 0%, ${T.accent}80 40%, transparent 100%)`,
      boxShadow: `0 0 12px ${T.accent}80, 0 0 4px ${T.accent}60`,
      animation: "sessionSweep 3s ease-in-out infinite",
      borderRadius: "50%",
    }} />
  </div>
);
export default SessionTopBar;
